import { render, staticRenderFns } from "./MarketCodeForm.vue?vue&type=template&id=6b566a1e&"
import script from "./MarketCodeForm.vue?vue&type=script&lang=js&"
export * from "./MarketCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports